var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isOnline)?_c('div',{staticClass:"network-status"},[_vm._v(" You are offline. Some features may not work. ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }